import { ChangeDetectionStrategy, Component, effect, input, model } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { debounceTime } from 'rxjs'

@Component({
  selector: 'search',
  imports: [ReactiveFormsModule],
  templateUrl: './search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent {
  placeholder = input<string>('Buscar...')
  searchTerm = model<string>('')

  searchControl = new FormControl('')

  constructor() {
    this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(value => {
      if (value !== null) this.searchTerm.set(value.trim())
    })

    effect(() => {
      const term = this.searchTerm()
      this.searchControl.setValue(term, { emitEvent: false })
    })
  }
}
